export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-arrows-compress-357fe6f087c2052466d91e15fedf18c2.svg";